import {
	CREATED_ACCOUNT, LOGOUT_BEGIN, LOGOUT_SUCCESS,
	SET_PLAYER,
	SIGNED_IN
} from "../actions/dashboard.js";
import { SHOW_LOGIN_POPUP_BEGIN, SHOW_LOGIN_POPUP_END } from "../actions/login.js";
import Cookies from 'js-cookie';

const initialState = {
	firstSetPlayerEventHappened: false,
	wasLoggedInOnFirstPlayerEvent: null,
	showingLoginPopup: false,
	justSignedIn: false,
	justCreatedAccount: false,
};


export default (state = initialState, action) => {
	switch(action.type) {
		case SET_PLAYER: {
			const player = action.payload;
			if(state.firstSetPlayerEventHappened) {
				return state;
			}
			const wasLoggedInOnFirstPlayerEvent = !!player.email;
			const showingLoginPopup = !wasLoggedInOnFirstPlayerEvent;
			return {
				...state,
				wasLoggedInOnFirstPlayerEvent,
				firstSetPlayerEventHappened: true,
				showingLoginPopup,
			};
		}
		case SIGNED_IN:
			return {
				...state,
				justSignedIn: true
			};
		case LOGOUT_BEGIN: {
			return {
				...state,
				...initialState,
			};
		}
		case LOGOUT_SUCCESS: {
			Cookies.remove('budget_login');
			return {
				...state
			};
		}
		case CREATED_ACCOUNT:
			return {
				...state,
				justCreatedAccount: true
			};
		case SHOW_LOGIN_POPUP_BEGIN: {
			return {
				...state,
				showingLoginPopup: true
			};
		}
		case SHOW_LOGIN_POPUP_END: {
			return {
				...state,
				showingLoginPopup: false,
			};
		}
		default:
			return state;
	}
}